"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a simple root store.
 */
function createRootStore(obj, factory) {
    var result = {};
    factory =
        factory || (function (storeClass, rootStore) { return new storeClass({ rootStore: rootStore }); });
    Object.keys(obj).forEach(function (key) {
        var val = obj[key];
        result[key] = typeof val === 'function' ? factory(val, result) : val;
    });
    return result;
}
exports.createRootStore = createRootStore;
//# sourceMappingURL=root-store.js.map